import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { AppService } from "src/app/core/services/app.service";
import { FormValidationService } from "src/app/core/services/form-validation.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { TransactionType } from "src/app/shared/models/enums/transaction-types.enum";
import { OOPromoCode } from "src/app/shared/models/OOPromoCode.item";

@Component({
	selector: "app-promo-code-record-view",
	templateUrl: "./promo-code-record-view.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class PromoCodeRecordViewComponent implements OnInit, OnDestroy, OnChanges {
	@Input() promoCodeSelected: OOPromoCode;
	@Output() promoCodeSelectedChange = new EventEmitter<OOPromoCode>();
	constructor(public app: AppService, public venueSvc: OOVenueService, private formValidationService: FormValidationService) {}

	controlPromoCodeCode: UntypedFormControl;
	controlPromoCodeValue: UntypedFormControl;

	transactionTypes: { label: string; value: number }[] = [];

	ngOnInit(): void {
		this.controlPromoCodeValue = new UntypedFormControl({ value: this.promoCodeSelected.value }, [Validators.required]);

		for (const [k, v] of Object.entries(TransactionType)) {
			if (!isNaN(+v)) {
				this.transactionTypes.push({
					label: k,
					value: +v,
				});
			}
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes.promoCodeSelected) {
			this.controlPromoCodeCode = new UntypedFormControl({ value: this.promoCodeSelected.promoCode }, [Validators.required]);
			setTimeout(() => {
				this.controlPromoCodeCode.addValidators(
					this.formValidationService.duplicateValue(
						this.controlPromoCodeCode,
						this.venueSvc.ooPromoCodes,
						"promoCode",
						"key",
						this.promoCodeSelected.key
					)
				);
			}, 500);
		}
	}

	ngOnDestroy(): void {
		this.promoCodeSelectedChange.emit(undefined);
	}

	onDelete() {
		this.venueSvc.ooPromoCodeDelete(this.promoCodeSelected);
		this.app.msgSvc.add({ severity: AppMessageSeverity.DANGER, summary: "", detail: `${this.promoCodeSelected.promoCode} deleted.` });
		this.promoCodeSelectedChange.emit(undefined);
	}

	onSave() {
		this.venueSvc.ooPromoCodeSave(this.promoCodeSelected);
		this.app.msgSvc.add({ severity: AppMessageSeverity.GREEN, summary: "", detail: `${this.promoCodeSelected.promoCode} saved.` });
	}
}
